import { render, staticRenderFns } from "./TempConfigFormList.vue?vue&type=template&id=1983b22f&scoped=true"
import script from "./TempConfigFormList.vue?vue&type=script&lang=js"
export * from "./TempConfigFormList.vue?vue&type=script&lang=js"
import style0 from "./TempConfigFormList.vue?vue&type=style&index=0&id=1983b22f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1983b22f",
  null
  
)

export default component.exports